// Months array for date formatting
const months: Array<string> = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

// Character limit for suggestion api
const suggestionApiQueryMaxlength: number = 70;

// Character limit for job search api
const jobSearchQueryMaxlength: number = 40;

const ACTIVE_FEATURE_FLAGS: string[] = [];

// image widths within the lead media.
const LEAD_MEDIA_SMALL_WIDTH = 375;
const LEAD_MEDIA_MEDIUM_WIDTH = 567;
const LEAD_MEDIA_LARGE_WIDTH = 700;
const LEAD_MEDIA_ASPECT_HEIGHT = 9;
const LEAD_MEDIA_ASPECT_WIDTH = 16;

// Screen widths
const LARGE_SCREEN_WIDTH_MIN = 1200;
const MEDIUM_SCREEN_WIDTH_MAX = 1199;
const MEDIUM_SCREEN_WIDTH_MIN = 992;
const SMALL_SCREEN_WIDTH_MAX = 991;
const SMALL_SCREEN_WIDTH_MIN = 768;
const EXTRA_SMALL_SCREEN_WIDTH_MAX = 767;

const FIXED_NAV_TABLET_HEIGHT = 64;

const JOB_ALERT_EXCLUDED_COMPANY_NAMES = ["squarespace"];
const JOB_ALERT_EXCLUDED_TAGS = ["anti-racism"];
const NEWSLETTER_EXCLUDED_LANDING_PAGES = [
    "employer-resources",
];
const NEWSLETTER_EXCLUDED_PAGES = [
    "interview-questions-and-answers",
    "employer-resources",
];
const NEWSLETTER_EXCLUDED_TAGS = [
    "employer-resources"
];
const NEWSLETTER_EXCLUDED_PRIMARY_TOPICS = [
    "employer-resources"
];
const JOB_ALERT_EXCLUDED_LANDING_PAGES = [
    "anti-racism-at-work",
    "work-relationships",
    "job-offer",
    "management",
    "interviewing",
    "break-room",
    "money",
    "work-life-balance",
    "employer-resources",
    "changing-jobs",
    "career-stories"
];
const JOB_ALERT_EXCLUDED_PRIMARY_TOPICS = [
    "anti-racism-at-work",
    "work-relationships",
    "job-offer",
    "management",
    "interviewing",
    "break-room",
    "money",
    "work-life-balance",
    "employer-resources",
    "changing-jobs",
    "career-stories"
];

const AMP_EXCLUDED_ARTICLES = [
    "advice/10-questions-ask-job-interview-avoid-bad-boss",
    "advice/3-better-ways-to-answer-why-should-we-hire-you",
    "advice/3-steps-for-answering-why-do-you-want-this-job",
    "advice/3-ways-to-stop-thinking-about-work-when-youre-not-there",
    "advice/43-resume-tips-that-will-help-you-get-hired",
    "advice/5-email-templates-to-respond-to-recruiters-no-matter-where-you-are-in-your-search",
    "advice/5-real-reasons-youre-getting-radio-silence-after-a-final-interview",
    "advice/5-things-youre-forgetting-to-ask-during-your-review",
    "advice/6-types-of-stories-you-should-have-on-hand-for-job-interviews",
    "advice/7-better-ways-to-answer-what-do-you-do",
    "advice/7-steps-to-avoid-crying-in-the-workplace",
    "advice/9-famous-people-who-will-inspire-you-to-never-give-up",
    "advice/a-realistic-approach-to-dealing-with-people-who-dont-like-you",
    "advice/account-manager-interview-questions-answers-examples",
    "advice/better-ways-to-follow-up-than-per-my-last-email",
    "advice/coming-late-to-work-email",
    "advice/companies-to-work-for-in-customer-service",
    "advice/email-templates-start-a-new-job",
    "advice/greatest-accomplishment-interview-question-answer-examples",
    "advice/heres-a-template-to-write-a-perfect-and-personalized-letter-of-recommendation",
    "advice/high-paying-sales-jobs",
    "advice/how-to-answer-what-makes-you-unique-samples",
    "advice/how-to-answer-what-other-companies-are-you-interviewing-with",
    "advice/how-to-answer-whats-your-management-style",
    "advice/how-to-answer-where-do-you-see-yourself-in-5-years",
    "advice/how-to-negotiate-salary-37-tips-you-need-to-know",
    "advice/i-hope-this-email-finds-you-well-alternatives",
    "advice/include-links-job-application-resume-cover-letter",
    "advice/phone-interview-tips-preparation",
    "advice/professional-accomplishments-achievements-on-resume-examples",
    "advice/project-management-interview-questions-answers-examples",
    "advice/the-11-best-career-quizzes-to-help-you-find-your-dream-job",
    "advice/the-email-template-that-guarantees-your-reference-will-say-all-the-right-things",
    "advice/toxic-boss-signs-how-to-deal",
    "advice/what-do-you-like-least-about-your-job-interview-question-answer",
    "advice/what-is-an-internship-definition-advice",
    "advice/what-to-do-when-you-hate-your-job-and-you-dont-have-anything-else-lined-up-yet",
    "advice/how-to-write-an-interview-thankyou-note-an-email-template",
    "advice/51-interview-questions-you-should-be-asking",
    "advice/team-building-activities-games-for-work-office",
    "advice/185-powerful-verbs-that-will-make-your-resume-awesome",
];

export {
    months,
    jobSearchQueryMaxlength,
    suggestionApiQueryMaxlength,
    ACTIVE_FEATURE_FLAGS,
    LEAD_MEDIA_SMALL_WIDTH,
    LEAD_MEDIA_MEDIUM_WIDTH,
    LEAD_MEDIA_LARGE_WIDTH,
    LEAD_MEDIA_ASPECT_HEIGHT,
    LEAD_MEDIA_ASPECT_WIDTH,
    LARGE_SCREEN_WIDTH_MIN,
    MEDIUM_SCREEN_WIDTH_MAX,
    MEDIUM_SCREEN_WIDTH_MIN,
    SMALL_SCREEN_WIDTH_MAX,
    SMALL_SCREEN_WIDTH_MIN,
    EXTRA_SMALL_SCREEN_WIDTH_MAX,
    FIXED_NAV_TABLET_HEIGHT,
    JOB_ALERT_EXCLUDED_COMPANY_NAMES,
    JOB_ALERT_EXCLUDED_TAGS,
    JOB_ALERT_EXCLUDED_LANDING_PAGES,
    JOB_ALERT_EXCLUDED_PRIMARY_TOPICS,
    NEWSLETTER_EXCLUDED_LANDING_PAGES,
    NEWSLETTER_EXCLUDED_PAGES,
    NEWSLETTER_EXCLUDED_PRIMARY_TOPICS,
    NEWSLETTER_EXCLUDED_TAGS,
    AMP_EXCLUDED_ARTICLES
};
